import { userClass } from "./class/userApiClass";

const client = new userClass();

export default client;